export const name = "SIGN";
export const summary = `Produces -1 , 0, or +1 for negative, zero, and positive arguments respectively.`;
export const reference = `
## SIGN

Produces -1 , 0, or +1 for negative, zero, and positive arguments respectively.

\`\`\`
SIGN(X)
\`\`\`

### Description

Returns \`-1\`, \`0\`, or \`+1\` for negative, zero and positive arguments respectively. For floating point arguments, this function doesn't distinguish between positive and negative zero.

| X | SIGN(X) |
| --- | --- |
| 25 | +1 |
| 0 | 0 |
| -25 | -1 |
| NaN | NaN |


### Return Data Type

| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| --- | --- | --- | --- | --- |
| OUTPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
